import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../style.css";

// Import the new particle background
import ContactParticle from "../ContactParticle";

function Contact() {
  const [result, setResult] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending...");

    const form = event.target;
    const name = form.Name.value.trim();
    const email = form.Email.value.trim();
    const message = form.Message.value.trim();

    // Basic validation using toast
    if (!name) {
      toast.error("Please enter your name");
      setResult("");
      return;
    }

    if (!email) {
      toast.error("Please enter your email");
      setResult("");
      return;
    }

    // Optional: email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      setResult("");
      return;
    }

    if (!message) {
      toast.error("Please enter your message");
      setResult("");
      return;
    }
    const formData = new FormData(event.target);

    formData.append("access_key", "5f82cfd3-f227-4e31-8a0c-3e9c9488347a");

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        setResult("");
        toast.success("Form Submitted Successfully!");
        form.reset();
      } else {
        toast.error(data.message || "Something went wrong");
        setResult("");
      }
    } catch (error) {
      toast.error("Network error. Please try again later.");
      setResult("");
    }
  };

  return (
    <div style={{ position: "relative", overflow: "hidden" }}>
      <ContactParticle />

      <Container
        fluid
        className="contact-section"
        style={{ position: "relative", zIndex: 1 }}
      >
        <br />
        <br />
        <h1 className="project-heading">
          <strong className="purple">Contact Me</strong>
        </h1>
        <br />
        <p className="contact-description">
          Have a project in mind? Let's create something amazing together!
        </p>
        <div className="contact-form-container" id="Contact">
          {/* Contact Info Boxes */}
          <div className="contact-info-boxes">
            <div className="info-box">
              <div className="icon address-icon" />
              <div>
                <strong>Address</strong>
                <p>Ballari, Karnataka, India</p>
              </div>
            </div>
            <div className="info-box">
              <div className="icon phone-icon" />
              <div>
                <strong>Call Me</strong>
                <p>+91-8296064895</p>
              </div>
            </div>
            <div className="info-box">
              <div className="icon email-icon" />
              <div>
                <strong>Email Me</strong>
                <p>mujeebkhan3771@gmail.com</p>
              </div>
            </div>
          </div>
          <br />
          <form onSubmit={onSubmit} className="contact-form">
            <ToastContainer position="top-center" />
            <div className="form-row">
              <div className="form-group">
                <label>Your Name</label>
                <input
                  type="text"
                  name="Name"
                  placeholder="Your Name"
                  // required
                />
              </div>
              <div className="form-group">
                <label>Your Email</label>
                <input
                  type="email"
                  name="Email"
                  placeholder="Your Email"
                  // required
                />
              </div>
            </div>
            <div className="form-group full-width">
              <label>Your Message</label>
              <textarea
                name="Message"
                rows="4"
                placeholder="Message here..."
                // required
              ></textarea>
            </div>
            <button type="submit" className="submit-button">
              {result ? result : "Send Message"}
            </button>
          </form>
        </div>
        <br />
      </Container>
    </div>
  );
}

export default Contact;
